import { h } from 'preact'

import { heroImgSources } from '../../lib/utils'

const Hero = (props) => (
  <section class='hero-search dark-overlay bg-cover' style={`background-image: url(${heroImgSources[Math.floor(Math.random() * heroImgSources.length)]})`}>
    <div class='container py-6 text-white z-index-20 overlay-content'>
      <div class='row'>
        <div class='col-xl-10'>
          <div class='text-center text-lg-left'>
            <h1 class='display-3 font-weight-bold text-shadow'>{props.title}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
)

export default Hero
